import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const AutocompleteWrapper = styled.div`
  .multi-select-search,
  &.multi-select-search {
    position: relative;

    .MuiAutocomplete-popper {
      top: calc(100% - 4px);

      .MuiAutocomplete-listbox {
        max-height: 274px;
        padding: 4px 0;

        ${breakpoints.down('sm')} {
          max-height: 166px;
        }
      }
    }

    &__input {
      .MuiInputBase-input {
        font-size: 17px;
        font-weight: 500;
        line-height: 30px;
      }

      .MuiInputBase-root {
        background-color: ${WHITE};
        padding: 4.5px 12px 4.5px 8px;
      }

      .Mui-disabled {
        *,
        ::placeholder {
          color: ${p => p.theme.palette.text.disabled} !important;
        }
      }
    }

    &__input-adornment {
      font-size: 24px;

      &--open {
        transform: rotate(-180deg);
      }
    }

    &__option {
    }
  }

  .MuiAutocomplete-option {
    padding: 0;

    &[aria-selected='true'] {
      color: inherit;
    }

    &[aria-selected='true']:not([data-focus='true']) {
      background-color: transparent;
    }
  }
`;

export const ListItem = styled.div`
  font-size: 18px;
  line-height: 30px;
  padding: 12px 18px 12px 40px;
  white-space: normal;
  word-break: break-word;
  color: ${p => (p.selected ? p.theme.palette.primary.main : 'inherit')};
  font-weight: ${p => (p.have ? '700' : 'inherit')};
  width: 100%;
  position: relative;

  i {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translate(-50%, -50%);
    font-size: 13px;
    opacity: ${p => (p.selected ? 1 : 0)};
  }
`;

export const NoResults = styled.div`
  color: ${p => p.theme.palette.text.primary};
  cursor: default;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.4rem;
`;
